import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

type WalletBalanceDto = {
  balance: number;
  creditConversionRate: number;
};

export const GET_ADMIN_WALLET_BALANCE_QUERY_KEY = (userId: string) => [
  'wallet',
  'admin',
  'balance',
  userId,
];

export const useGetAdminWalletBalance = (userId: string) => {
  const client = useApiClient();

  return useQuery({
    queryKey: GET_ADMIN_WALLET_BALANCE_QUERY_KEY(userId),
    queryFn: () =>
      client.fetchApi<WalletBalanceDto, {}>({
        endpoint: `wallet/admin/balance/${userId}`,
        method: 'GET',
      }),
    enabled: Boolean(userId),
    staleTime: 30_000,
  });
};
